import axios from "axios";
import AuthApi from "@/apis/authApi";

/**
 * This module for authentication
 */
export default {
    namespaced: true,

    state: {
        user: {},
        token: ""
    },

    getters: {
        isLogged(state) {
            return !!state.token;
        }
    },

    mutations: {
        SET_USER(state, user) {
            state.user = user;
        },
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        },
        CLEAR_TOKEN(state) {
            state.token = null;
            state.user = {};
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            axios.defaults.headers.common["Authorization"] = null;
        }
    },

    actions: {
        login({ commit }, credentials) {
            return AuthApi.login(credentials).then(r => {
                commit("SET_USER", r.data.user);
                commit("SET_TOKEN", r.data.token);
            });
        },

        logout({ commit }) {
            return AuthApi.logout().then(() => {
                commit("CLEAR_TOKEN");
                location.reload();
            });
        },

        checkIfUserAuthenticated({ commit }) {
            return new Promise(function(myResolve, myReject) {
                if (!localStorage.getItem("token")) return myResolve();

                commit("SET_TOKEN", localStorage.getItem("token"));
                return AuthApi.profile()
                    .then(r => {
                        commit("SET_USER", r.data);
                        myResolve(r);
                    })
                    .catch(e => {
                        commit("CLEAR_TOKEN");
                        myReject(e);
                    });
            });
        }
    }
};
